// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"af06f971","202":"0a15e699","310":"1b5b7cad","364":"db536ad1","412":"e7d3bca5","489":"99c33ecd","546":"03ef9071","669":"86d5eb4f","673":"40d46be3","831":"a16fa13c","904":"c2b75c59","940":"07d6e4f1","986":"ff13afce"}[chunkId] + ".chunk.js";
};